<template>
  <div
    v-if="showRegisterNow"
    class="h-[15rem]"
    :style="{
      backgroundColor: `#${backgroundColor}`,
    }"
  >
    <div class="flex justify-center grid grid-rows-3 h-full py-8">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="text-center font-bold text-white text-2xl sm:text-4xl"
        v-html="__('lander_003_footer_text')"
      />
      <!-- eslint-enable vue/no-v-html -->

      <div class="flex justify-center my-auto pt-4">
        <div
          class="w-[18rem] h-[4rem] cursor-pointer p-4 rounded-md"
          :style="{
            backgroundColor: `#${primaryColor}`,
          }"
          @click="scrollToTop()"
        >
          <p class="text-center text-white text-xl font-bold h-full align-baseline mt-0.5">
            {{ __('label_get_started_now') }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="p-2"
    :style="{
      backgroundColor: `#${backgroundColor}`,
    }"
  />

  <div class="bg-gray-100">
    <div class="w-full flex justify-center pt-12">
      <Component
        :is="config.footer?.review_image_href ? 'a' : 'div'"
        class="inline-flex"
        :class="!!config.footer?.review_image_href ? 'cursor-pointer' : ''"
        :href="config.footer?.review_image_href"
        target="_blank"
      >
        <div v-if="!!config.footer?.review_score">
          <p class="text-gray-500 text-lg text-right mr-2">
            {{ config.footer?.review_score }}
          </p>
        </div>

        <img
          v-if="config.footer?.reviews_image_url"
          class="h-6 object-contain"
          :src="config.footer?.reviews_image_url"
          alt="reviews"
        >
        <img
          v-else
          class="h-6 object-contain"
          src="@timon/js/Templates/LANDER-003/assets/reviews.png"
          alt="reviews"
        >

        <div>
          <p class="text-gray-500 text-lg text-left ml-2">
            {{ (config.footer?.review_count ?? '0') + ' ' + __('label_reviews') }}
          </p>
        </div>
      </Component>
    </div>

    <div class="w-full pt-12 flex justify-center">
      <div class="h-full 2xl:min-w-[600px] space-x-2 inline-flex justify-center">
        <div
          v-for="(page, index) in pages"
          :key="index"
          class="justify-center"
        >
          <div
            class="underline cursor-pointer text-lg text-gray-500 inline-flex"
            @click="router.get(pageUrl('LANDER-003', page.slug))"
          >
            <p>
              {{ page.title }}
            </p>

            <p
              v-if="index < pages.length - 1"
              class="text-gray-500 ml-2"
            >
              |
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- eslint-disable vue/no-v-html -->
    <div
      class="text-center text-gray-500 w-full py-4"
      v-html="config.footer?.text"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>

  <div class="w-full" />
</template>

<script setup>
import {ref} from 'vue';
import {router} from '@inertiajs/vue3';
import {pageUrl} from '@timon/js/Mixins/helpers';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  pages: {
    type: Array,
    required: true,
  },

  collectorFlowUuid: {
    type: String,
    required: true,
  },

  showRegisterNow: {
    type: Boolean,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
const backgroundColor = ref(props.config.style?.footer_background);

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
</script>
